import { render, staticRenderFns } from "./ResetGrids.vue?vue&type=template&id=73c2cb44&scoped=true&"
import script from "./ResetGrids.vue?vue&type=script&lang=js&"
export * from "./ResetGrids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2cb44",
  null
  
)

export default component.exports